import { TrendingUp } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { ForecastEntryPage } from './pages/ForecastEntryPage'
import { ForecastRollupPage } from './pages/ForecastRollupPage'

/**
 * Customer Demand Forecast (V1).
 *
 * Sales reps enter forecasted product quantities per customer over
 * flexible date-range periods (a monthly figure, an EOY lump sum, a
 * first-6-months lump sum, etc. — freeform, not a fixed monthly grid).
 * Procurement/operations read a rollup for planning. Read-only rollup
 * + CSV export only in V1 — no changes to existing purchasing/reorder-
 * point tools, no CARLA/chat tool.
 *
 * navSection 'sales' mirrors Quotes: rep-authored, with visibility
 * extended to procurement-consuming roles via `permissions` rather than
 * living in a separate section.
 */
export default defineModule({
  id: 'demand-forecast',
  name: 'Demand Forecast',
  shortName: 'Forecast',
  icon: TrendingUp,
  navSection: 'sales',
  navOrder: 60,
  urlNamespace: '/demand-forecast',
  routes: [
    { path: '/', element: ForecastEntryPage, label: 'Demand Forecast' },
    {
      path: '/rollup',
      element: ForecastRollupPage,
      label: 'Procurement Rollup',
      // Narrower than the module's own permissions: reps enter data but
      // don't get the aggregate cross-customer rollup view in V1 (matches
      // the backend's _ROLLUP_ROLES gate).
      permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'sales'],
    },
  ],
  permissions: [
    'admin', 'sales', 'outside_sales_rep', 'inside_sales_rep',
    'operations', 'operations_logistics', 'purchasing',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',
  // 'g f' is Fulfillment Risk; 'g f c' ("forecast, customer") is free.
  keyboardShortcut: 'g f c',
  commandPaletteEntries: [
    {
      label: 'Go to Demand Forecast',
      keywords: ['forecast', 'demand', 'procurement', 'planning', 'sales'],
      path: '/',
      group: 'modules',
      shortcut: 'g f c',
    },
  ],
})
